<!-- Компактный workflow документа из готового backend-контракта document_flow. -->
<template>
  <div v-if="flow && titleGroups.length" class="edo-flow-cell">
    <BaseTooltip
      variant="light"
      position="top"
      :max-width="260"
      close-on-click
    >
      <button
        type="button"
        class="edo-flow-cell__button"
        :aria-label="ariaLabel"
      >
        <span class="edo-flow-cell__segments">
          <EdoDocumentFlowSegment
            v-for="group in titleGroups"
            :key="group.key"
            :steps="group.steps"
            :group-tone="group.tone"
            :active-step-key="group.active_step_key"
          />
        </span>
        <span
          class="edo-flow-cell__label"
          :class="`edo-flow-cell__label--${overallTone}`"
        >
          {{ currentLabel }}
        </span>
      </button>

      <template #content>
        <EdoDocumentFlowCellTooltip
          :document-label="documentLabel"
          :groups="tooltipGroups"
          :completed-count="completedCount"
        />
      </template>
    </BaseTooltip>
  </div>
  <span v-else class="edo-flow-cell__empty">—</span>
</template>

<script>
import EdoDocumentFlowCellTooltip from "@/components/Edo/shared/EdoDocumentFlowCellTooltip.vue";
import EdoDocumentFlowSegment from "@/components/Edo/shared/EdoDocumentFlowSegment.vue";
import { edoDocumentFlowParticipantTimelineLabel } from "@/utils/edoDocumentFlowParticipantUtils";

export default {
  name: "EdoDocumentFlowCell",

  components: {
    EdoDocumentFlowCellTooltip,
    EdoDocumentFlowSegment,
  },

  props: {
    flow: {
      type: Object,
      default: null,
    },
  },

  computed: {
    allSteps() {
      return Array.isArray(this.flow?.steps) ? this.flow.steps : [];
    },

    titleGroups() {
      const stepsByKey = new Map(this.allSteps.map((step) => [step.key, step]));
      const groups = Array.isArray(this.flow?.groups) ? this.flow.groups : [];

      // Состав титулов приходит готовым: здесь только связываем backend-группу
      // с её шагами для отрисовки двух половин компактного сегмента.
      return groups.map((group) => ({
        ...group,
        steps: group.step_keys.map((key) => stepsByKey.get(key) || null),
      }));
    },

    tooltipGroups() {
      return this.titleGroups.map((group) => {
        return {
          ...group,
          actor: group.participant_label || edoDocumentFlowParticipantTimelineLabel(group.participant),
          statusLabel: group.status_label,
          tone: group.tone || "neutral",
        };
      });
    },

    completedCount() {
      return this.titleGroups.filter((group) => group.status === "done").length;
    },

    overallTone() {
      return this.flow?.tone || "neutral";
    },

    currentLabel() {
      return this.flow?.short_label || this.flow?.current_label || "Нет текущего этапа";
    },

    documentLabel() {
      return this.flow?.document_label || "Документ ЭДО";
    },

    ariaLabel() {
      return `${this.documentLabel}: ${this.currentLabel}`;
    },
  },

};
</script>

<style scoped>
.edo-flow-cell {
  min-width: 200px;
  max-width: 320px;
}

.edo-flow-cell__button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 200px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.edo-flow-cell__button:focus-visible {
  outline: 2px solid rgba(37, 99, 235, 0.45);
  outline-offset: 4px;
  border-radius: 3px;
}

.edo-flow-cell__segments {
  display: flex;
  gap: 3px;
}

.edo-flow-cell__label {
  overflow: hidden;
  max-width: 100%;
  color: #4b5060;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.edo-flow-cell__label--warning {
  color: #854d0e;
}

.edo-flow-cell__label--success {
  color: var(--color-green-hover);
}

.edo-flow-cell__label--danger {
  color: var(--color-danger-hover);
}

.edo-flow-cell__empty {
  color: #9ca3af;
}
</style>
